import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { InputRadioButtonComponent } from './input-radio-button.component';

@NgModule({
  declarations: [InputRadioButtonComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [InputRadioButtonComponent],
})
export class InputRadioButtonModule {}
